import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=051a020a&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=ts"
export * from "./StatCard.vue?vue&type=script&lang=ts"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=051a020a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a020a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,AnalyzerLogo: require('/app/components/AnalyzerLogo.vue').default,Ticker: require('/app/components/Common/Ticker.vue').default,ZTag: require('/app/components/zeal/ZTag/ZTag.vue').default})
